<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Novo Horário' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-card-content>
    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ng-container>
        <div class="border-bottom">
          <app-prover-horas
            [labelName]="'Hora Início'"
            [id]="'horarioInicio'"
            formControlName="horarioInicio"
            [required]="true"
            [isLabel]="true"
          ></app-prover-horas>

          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.horarioInicio">
              <div
                class="error-message"
                *ngIf="validations_form.get('horarioInicio')?.hasError(validation.type) && (validations_form.get('horarioInicio')?.dirty ||
                  validations_form.get('horarioInicio')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container>
        <div class="border-bottom">
          <app-prover-horas
            [labelName]="'Horário Fim'"
            [id]="'horarioFim'"
            formControlName="horarioFim"
            [required]="true"
            [isLabel]="true"
          ></app-prover-horas>

          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.horarioFim">
              <div
                class="error-message"
                *ngIf="validations_form.get('horarioFim')?.hasError(validation.type) && (validations_form.get('horarioFim')?.dirty ||
                  validations_form.get('horarioFim')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div class="border-bottom">
        <div class="ion-margin-horizontal">
          <ion-select
            interface="action-sheet"
            cancelText="{{ 'Cancelar' | translate}}"
            okText="{{ 'Confirmar' | translate}}"
            formControlName="diaSemana"
            label-placement="stacked"
          >
            <div slot="label" class="slot-label">{{'Dia da Semana' | translate}} <ion-text color="danger">*</ion-text></div>

            <ion-select-option *ngFor="let d of diaSemanaList" [value]="d.id">{{d.nome}}</ion-select-option>
          </ion-select>
        </div>
      </div>

      <div class="validation-errors">
        <ng-container *ngFor="let validation of validation_messages.diaSemana">
          <div
            class="error-message"
            *ngIf="validations_form.get('diaSemana')?.hasError(validation.type) && (validations_form.get('diaSemana')?.dirty ||
                validations_form.get('diaSemana')?.touched)"
          >
            {{ validation.message }}
          </div>
        </ng-container>
      </div>

      <div class="border-bottom">
        <div class="ion-margin-horizontal">
          <ion-select
            interface="action-sheet"
            cancelText="{{ 'Cancelar' | translate}}"
            okText="{{ 'Confirmar' | translate}}"
            formControlName="frequenciaDias"
            label-placement="stacked"
          >
            <div slot="label" class="slot-label">{{'Acontece a Cada' | translate}} <ion-text color="danger">*</ion-text></div>

            <ion-select-option *ngFor="let p of periodoList" [value]="p.id">{{p.nome}}</ion-select-option>
          </ion-select>
        </div>
      </div>

      <div class="validation-errors">
        <ng-container *ngFor="let validation of validation_messages.frequenciaDias">
          <div
            class="error-message"
            *ngIf="validations_form.get('frequenciaDias')?.hasError(validation.type) && (validations_form.get('frequenciaDias')?.dirty ||
                validations_form.get('frequenciaDias')?.touched)"
          >
            {{ validation.message }}
          </div>
        </ng-container>
      </div>

      <ion-grid>
        <ion-row class="ion-justify-content-center">
          <ion-col size="7">
            <ion-button class="btn-success" expand="block" type="submit" [disabled]="!validations_form.valid">
              {{'Salvar' | translate}}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-card-content>
</ion-content>
